import http from '@/plugins/http'
const adminApi = process.env.VUE_APP_ADMIN_API;
//获取 车型库 筛选配置
export const getCarFilterConfig = (params={}) => {
    const url = adminApi  + 'drivingReport/car/filterConfig'
    return http.fetchGet(url, params);
}
//获取车型库 筛选结果 更换车型 
export const getCarLibrary = (params={}) => {
    const url = adminApi  + 'drivingReport/car'
    return http.fetchGet(url, params);
}



//获取我的车型
export const getMyCar = (params={}) => {
    const url = adminApi  + 'drivingReport/user/personalizationCarList'
    return http.fetchPost(url, params);
}